import { render, staticRenderFns } from "./channelGroup.vue?vue&type=template&id=afb2124a&"
import script from "./channelGroup.vue?vue&type=script&lang=js&"
export * from "./channelGroup.vue?vue&type=script&lang=js&"
import style0 from "./channelGroup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports